(() => {
  if (window.movaFeaturedReviewsStarted) return;
  window.movaFeaturedReviewsStarted = true;
  const update = () => {
    document.querySelectorAll('[data-mova-review-slot]').forEach(slot => {
      if (Number(slot.dataset.reviewCount) < 1) return;
      const widgets = [...document.querySelectorAll('#judgeme_product_reviews')];
      const widget = widgets.find(w => (w.dataset.productId || w.dataset.id) === slot.dataset.productId);
      if (!widget) return;
      const cards = [...widget.querySelectorAll('.jm-review-item, .jdgm-rev')];
      const preferred = slot.dataset.reviewPreferred?.trim().toLowerCase();
      const named = preferred && cards.find(c => c.querySelector('.jm-reviewer-info__name, .jdgm-rev__author')?.textContent.trim().toLowerCase() === preferred);
      const card = named || cards.find(c => c.querySelector('.jm-media-thumbnail-list__thumbnail img, .jm-highlight-thumbnail img, .jdgm-rev__pic-img')) || cards[0];
      if (!card) return;
      const name = card.querySelector('.jm-reviewer-info__name, .jdgm-rev__author')?.textContent.trim();
      const quote = card.querySelector('.jdgm-review-content__body-content, .jdgm-rev__body')?.textContent.trim();
      const ratingNode = card.querySelector('.jm-star-rating, .jdgm-rev__rating');
      const rating = Number(ratingNode?.dataset.score || ratingNode?.getAttribute('aria-label')?.match(/[0-5](?:\.[0-9]+)?/)?.[0]);
      if (!name || !quote || !(rating > 0 && rating <= 5)) return;
      const sourceImage = card.querySelector('.jm-media-thumbnail-list__thumbnail img, .jm-highlight-thumbnail img, .jdgm-rev__pic-img');
      const signature = name + quote + (sourceImage?.src || '');
      if (slot.dataset.reviewSignature === signature) return;
      slot.dataset.reviewSignature = signature;
      slot.querySelector('.mova-featured-review__photo')?.remove();
      slot.classList.remove('mova-featured-review--customer-photo');
      slot.querySelector('[data-review-name]').textContent = name;
      const excerpt = slot.dataset.reviewExcerpt?.trim();
      const normalize = value => value.replace(/\s+/g,' ').trim().toLowerCase();
      const featuredQuote = excerpt && normalize(quote).includes(normalize(excerpt)) ? excerpt : quote;
      slot.querySelector('[data-review-quote]').textContent = `“${featuredQuote}”`;
      const stars = slot.querySelector('.mova-featured-review__stars');
      stars.textContent = '★'.repeat(Math.round(rating)) + '☆'.repeat(5 - Math.round(rating));
      stars.setAttribute('aria-label', `${rating} out of 5 stars`);
      if (sourceImage?.src) {
        const image = document.createElement('img');
        image.className = 'mova-featured-review__photo';
        image.src = sourceImage.src;
        image.alt = `Photo from ${name}’s review`;
        image.width = image.height = 48;
        image.loading = 'lazy';
        slot.prepend(image);
        slot.classList.add('mova-featured-review--customer-photo');
      }
      slot.dataset.reviewReady = 'true';
      slot.hidden = false;
    });
  };
  let scheduled = false;
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; update(); });
  });
  observer.observe(document.documentElement, {childList: true, subtree: true});
  document.addEventListener('shopify:section:load', update);
  update();
})();
